/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import ReactDOM from 'react-dom';
import { useTheme, getContainer, getDocument } from '../utils/index.js';
import '@itwin/itwinui-css/css/dialog.css';
import { Dialog } from '../Dialog/index.js';
/**
 * Modal component which can wrap any content.
 * @example
 * <Modal
 *   isOpen={true}
 *   title='My modal'
 *   onClose={onClose}
 * >
 *   <ModalContent>
 *     Here is my modal content
 *   </ModalContent>
 *   <ModalButtonBar>
 *     <Button styleType='high-visibility'>
 *       Primary button
 *     </Button>
 *     <Button>
 *       Secondary button
 *     </Button>
 *   </ModalButtonBar>
 * </Modal>
 */
export const Modal = (props) => {
    const { isOpen = false, isDismissible = true, closeOnEsc = true, closeOnExternalClick = true, onClose, title, children, modalRootId = 'iui-react-portal-container', ownerDocument = getDocument(), ...rest } = props;
    useTheme();
    const [container, setContainer] = React.useState();
    React.useEffect(() => {
        setContainer(getContainer(modalRootId, ownerDocument));
        return () => setContainer(undefined);
    }, [ownerDocument, modalRootId]);
    return !!container ? (ReactDOM.createPortal(React.createElement(Dialog, { isOpen: isOpen, closeOnEsc: closeOnEsc, closeOnExternalClick: closeOnExternalClick, isDismissible: isDismissible, onClose: onClose, preventDocumentScroll: true, trapFocus: true, setFocus: true },
        React.createElement(Dialog.Backdrop, null),
        React.createElement(Dialog.Main, { "aria-modal": true, ...rest },
            React.createElement(Dialog.TitleBar, { titleText: title }),
            children)), container)) : (React.createElement(React.Fragment, null));
};
export default Modal;
